import React, { useState, useEffect } from "react";
import Loading from "../Components/Loading";
import * as api from "../api/api";
import FormRowData from "../Components/Agent/FormRowData";
import DropdownSearch from "../Components/DropdownSearch";
import DropdownSearchSingle from "../Components/DropdownSearchSingle";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import LastPageIcon from "@mui/icons-material/LastPage";
import Form from "react-bootstrap/Form";
import dayjs from "dayjs";
import { Button } from "@mui/material";
import YesNoModal from "../Components/Modal/YesNoModal";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import checkAuthorization from "../config/checkAuth";
import strings from "../Components/Localization/strings";
import { useLanguage } from "../Components/Localization/LanguageContext";
import "dayjs/locale/de";
import "dayjs/locale/en-gb";
import { Alert, Snackbar } from "@mui/material";

function AdminEditRecords(props) {
  const [isLoading, setLoading] = useState(false);
  const [historyForms, setHistoryForms] = useState([]);
  const { language } = useLanguage();
  const pageTitle = "AdminEditRecords";

  const activityTypes = strings[pageTitle][language].activityTypes;

  const [currentPage, setCurrentPage] = useState(1);
  const [numberOfPages, setNumberOfPages] = useState(1);
  const [numberOfItems, setNumberOfItems] = useState(0);
  const [minDate, setMinDate] = useState();
  const [processDataCache, setProcessDataCache] = useState({});

  const navigate = useNavigate();

  function getFormattedDate(date) {
    const today = date;

    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const day = today.getDate().toString().padStart(2, "0");
    const hours = "00";
    const minutes = "00";
    const seconds = "00";

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  const startDateString = getFormattedDate(new Date());
  const endDateString = getFormattedDate(
    new Date(Date.now() + 24 * 60 * 60 * 1000)
  );

  const [filter, setFilter] = useState({
    startDate: startDateString,
    endDate: endDateString,
    page: currentPage,
    size: 10,
    formIds: [],
    serviceIds: [],
    teamIds: [],
    userIds: [],
    processTypeIds: [],
    isBillable: null,
  });
  const [totalDurations, setTotalDurations] = useState("");
  const [services, setServices] = useState([]);
  const [forms, setForms] = useState([]);
  const [users, setUsers] = useState([]);
  const [teams, setTeams] = useState([]);
  const billableTypes = strings[pageTitle][language].billableTypes;
  const finalizedTypes = strings[pageTitle][language].finalizedTypes;
  const [selectedFromDate, setSelectedFromDate] = useState(dayjs());
  const [startEditingModal, setStartEditingModal] = useState({
    show: false,
    editReason: "",
  });
  const [currentEditingReason, setCurrentEditingReason] = useState("");
  const [snackbarData, setSnackbarData] = useState({ show: false });

  const handleDateFromChange = (date) => {
    const inputDate = new Date(date);

    if (dayjs(date).isBefore(minDate)) {
      return;
    }

    const year = inputDate.getFullYear();
    if (year < 1000 || year == undefined || isNaN(year)) {
      // Handle the case where the year is invalid
      console.error(strings[pageTitle][language].invalidYear);
      // You might also show a user-friendly error message to the user
      return;
    }

    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0");
    const day = inputDate.getDate().toString().padStart(2, "0");
    const hours = "00";
    const minutes = "00";
    const seconds = "00";

    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    handleFetchFilteredProcesses({ startDate: formattedDate });
    setSelectedFromDate(date);
  };

  const [selectedToDate, setSelectedToDate] = useState(dayjs());

  const handleDateToChange = (date) => {
    const inputDate = new Date(date);

    if (dayjs(date).isBefore(selectedFromDate)) {
      return;
    }

    const year = inputDate.getFullYear();
    if (year < 1000 || year == undefined || isNaN(year)) {
      // Handle the case where the year is invalid
      console.error("Invalid year. Please select a valid date.");
      // You might also show a user-friendly error message to the user
      return;
    }

    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0");
    const day = inputDate.getDate().toString().padStart(2, "0");
    const hours = "23";
    const minutes = "59";
    const seconds = "59";

    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    handleFetchFilteredProcesses({ endDate: formattedDate });

    setSelectedToDate(date);
  };
  // Convert elapsed time in milliseconds to hours:minutes:seconds format
  const pad = (timeValue) => {
    return timeValue.toString().padStart(2, "0");
  };
  const formatDuration = (time) => {
    let seconds = Math.floor(time / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    seconds = seconds % 60;
    minutes = minutes % 60;

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  };
  const initialiseFilterItems = () => {
    api.getAllServices().then((response) => {
      setServices(response.data.object);
    });
    api.getAllForms().then((response) => {
      setForms(response.data.object);
    });
    api.getAllUsers().then((response) => {
      let users = response.data.object;

      setUsers(users);
    });
    api.getAllTeams().then((response) => {
      setTeams(response.data.object);
    });
  };
  const handleCalculateDurations = (searchResult) => {
    let totalDuration = 0;
    searchResult.forEach((process) => {
      if (process.allProcessTimes) {
        console.log("in handle if cond");
        let sumDurations = 0;
        for (let i = 0; i < process.allProcessTimes.length; i++) {
          if (process.allProcessTimes[i].duration) {
            sumDurations = sumDurations + process.allProcessTimes[i].duration;
          }
        }
        totalDuration += sumDurations;
      }
    });
    totalDuration = totalDuration * 1000;
    setTotalDurations(formatDuration(totalDuration));
  };
  const handleFetchFilteredProcesses = (values, page = 1) => {
    let searchParts = values;
    console.log("search parts: ", searchParts);
    try {
      searchParts = {
        [values.split(":")[0]]: values.split(":")[1].split(","),
      };
      if (searchParts.hasOwnProperty("processTypeIds")) {
        let idValues = [];
        console.log(searchParts["processTypeIds"]);
        searchParts.processTypeIds.forEach((value) => {
          function findIdByName(name) {
            const activity = activityTypes.find(
              (activity) => activity.name === name
            );
            return activity ? activity.id : null;
          }
          idValues.push(findIdByName(value));
        });
        if (idValues[0] === null) {
          searchParts.processTypeIds = null;
        } else {
          searchParts.processTypeIds = idValues;
        }
      } else if (searchParts.hasOwnProperty("serviceIds")) {
        let idValues = [];
        console.log(searchParts.serviceIds);
        searchParts.serviceIds.forEach((value) => {
          function findIdByName(name) {
            const activity = services.find((service) => service.name === name);
            return activity ? activity.serviceId : null;
          }
          idValues.push(findIdByName(value));
        });
        if (idValues[0] === null) {
          searchParts.serviceIds = null;
        } else {
          searchParts.serviceIds = idValues;
        }
      } else if (searchParts.hasOwnProperty("formIds")) {
        let idValues = [];
        searchParts.formIds.forEach((value) => {
          function findIdByName(name) {
            const activity = forms.find((form) => form.name === name);
            return activity ? activity.formId : null;
          }
          idValues.push(findIdByName(value));
        });
        if (idValues[0] === null) {
          searchParts.formIds = null;
        } else {
          searchParts.formIds = idValues;
        }
      } else if (searchParts.hasOwnProperty("userIds")) {
        let idValues = [];
        searchParts.userIds.forEach((value) => {
          function findIdByName(username) {
            const user = users.find((user) => user.username === username);
            return user ? user.userId : -1;
          }
          idValues.push(findIdByName(value));
        });

        if (idValues[0] === -1 && idValues.length === 1) {
          console.log("hena");
          searchParts.userIds = [];
        } else {
          console.log(idValues);
          searchParts.userIds = idValues;
        }
        console.log(searchParts);
      } else if (searchParts.hasOwnProperty("teamIds")) {
        let idValues = [];
        searchParts.teamIds.forEach((value) => {
          function findIdByName(name) {
            const activity = teams.find((team) => team.name === name);
            return activity ? activity.teamId : null;
          }
          idValues.push(findIdByName(value));
        });
        searchParts.teamIds = idValues;
      } else if (searchParts.hasOwnProperty("isBillable")) {
        if (searchParts["isBillable"] == "true") {
          searchParts["isBillable"] = true;
        } else if (searchParts["isBillable"] == "false") {
          searchParts["isBillable"] = false;
        } else {
          searchParts["isBillable"] = null;
        }
      } else if (searchParts.hasOwnProperty("isFinalized")) {
        if (searchParts["isFinalized"] == "true") {
          searchParts["isFinalized"] = true;
        } else if (searchParts["isFinalized"] == "false") {
          searchParts["isFinalized"] = false;
        } else {
          searchParts["isFinalized"] = null;
        }
      }
      console.log(searchParts);
    } catch (e) {
      console.log(e);
      console.log(searchParts);
    }

    const updatedFilter = { ...filter, ...searchParts, page: page };
    setCurrentPage(page);
    setLoading(true);
    setFilter(updatedFilter);

    api.getAllFilteredReports(updatedFilter).then((response) => {
      console.log(response.data.object);
      setNumberOfPages(response.data.object.totalPages);
      console.log("the filter used is: ", updatedFilter);
      const { current, history } = response.data.object;
      console.log("history: ", history);
      handleCalculateDurations(history);

      const sortedArray = history.sort((a, b) => a.processId - b.processId);

      setHistoryForms(sortedArray);

      if (
        response.data.object.currentPage === 1 &&
        response.data.object.size === 0
      ) {
        setCurrentPage(0);
      }
      setNumberOfItems(response.data.object.history?.length || 0);
      setLoading(false);
    });
  };
  useEffect(() => {
    //let proceed = checkAuthorization();

    checkAuthorization("EDIT_RECORDS").then((result) => {
      if (result) {
        handleFetchFilteredProcesses();
        initialiseFilterItems();
        api
          .getAppSettingsOfTenantByTenantId(
            JSON.parse(sessionStorage.getItem("userTenant"))?.tenantId
          )
          .then((response) => {
            console.log(response.data.object);
            setMinDate(
              dayjs()
                .subtract(
                  response.data.object.trackedActivitiesDisplayDurationMonths,
                  "months"
                )
                .startOf("day")
            );
          });
      } else {
        navigate("/unauthorized");
      }
    });
  }, []);
  return (
    <div className="main-content-container">
      <YesNoModal
        handleYes={() => {
          setCurrentEditingReason(startEditingModal.editReason);
        }}
        handleShowModal={() =>
          setStartEditingModal({ ...startEditingModal, show: false })
        }
        propShow={startEditingModal.show}
        YesText={strings[pageTitle][language].yesText}
        NoText={strings[pageTitle][language].noText}
        title={strings[pageTitle][language].title}
        YesDisabled={!startEditingModal.editReason}
      >
        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
          <Form.Label className="grid-item-title">
            {strings[pageTitle][language].reason}
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={startEditingModal.editReason}
            onChange={(e) => {
              setStartEditingModal({
                ...startEditingModal,
                editReason: e.target.value,
              });
            }}
          />
        </Form.Group>
      </YesNoModal>
      <div className="main-content">
        <div>
          <div className="main-content__title d-flex align-items-center justify-content-between">
            <h6 className="">{strings[pageTitle][language].pageTitle} </h6>
            <div className="d-flex align-items-center gap-5 justify-content-between">
              <div className="d-flex align-items-center gap-2 justify-content-between">
                <p style={{ whiteSpace: "nowrap" }}>
                  {strings[pageTitle][language].totalDuration}
                </p>
                <h5 className="total-duration">{totalDurations}</h5>
              </div>
              <button
                className="button-options-bar"
                style={{ alignSelf: "flex-end", margin: "1em" }}
                onClick={() => {
                  !currentEditingReason
                    ? setStartEditingModal({ ...startEditingModal, show: true })
                    : setStartEditingModal({ editReason: "", show: false });
                  setCurrentEditingReason("");
                }}
              >
                {currentEditingReason
                  ? strings[pageTitle][language].stop
                  : strings[pageTitle][language].start}
              </button>
            </div>
          </div>
          <hr className="main-content-title__hr" />
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            open={snackbarData.show}
            autoHideDuration={3000}
            onClose={() => setSnackbarData({ ...snackbarData, show: false })}
          >
            <Alert
              severity="success"
              onClose={() => setSnackbarData({ ...snackbarData, show: false })}
            >
              {strings[pageTitle][language].FormSavedMessage}
            </Alert>
          </Snackbar>
          <div className="ms-2 mt-2 d-flex gap-1 max-width-800 mx-auto p-3  flex-wrap">
            <h6 className="grid-item-title" style={{ whiteSpace: "nowrap" }}>
              {strings[pageTitle][language].filterBy}{" "}
            </h6>
            <DropdownSearch
              items={activityTypes}
              label="Activity Type"
              labelText={strings[pageTitle][language].filterItems[0]}
              triggerSearch={handleFetchFilteredProcesses}
            ></DropdownSearch>
            <DropdownSearch
              items={services}
              label="Services"
              labelText={strings[pageTitle][language].filterItems[1]}
              triggerSearch={handleFetchFilteredProcesses}
            ></DropdownSearch>
            <DropdownSearch
              items={forms}
              label="Forms"
              labelText={strings[pageTitle][language].filterItems[2]}
              triggerSearch={handleFetchFilteredProcesses}
            ></DropdownSearch>
            <DropdownSearch
              items={users}
              label="Users"
              labelText={strings[pageTitle][language].filterItems[3]}
              triggerSearch={handleFetchFilteredProcesses}
            ></DropdownSearch>
            <DropdownSearch
              items={teams}
              label="Teams"
              labelText={strings[pageTitle][language].filterItems[4]}
              triggerSearch={handleFetchFilteredProcesses}
            ></DropdownSearch>
            <DropdownSearchSingle
              items={strings[pageTitle][language].billableTypes}
              label="Billable"
              labelText={strings[pageTitle][language].filterItems[5]}
              triggerSearch={handleFetchFilteredProcesses}
            ></DropdownSearchSingle>

            <DropdownSearchSingle
              items={strings[pageTitle][language].finalizedTypes}
              label="Finalized"
              labelText={strings[pageTitle][language].filterItems[6]}
              triggerSearch={handleFetchFilteredProcesses}
            ></DropdownSearchSingle>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <div style={{ width: "150px", marginTop: "0px" }}>
                <DatePicker
                  label={strings[pageTitle][language].filterItems[7]}
                  onChange={handleDateFromChange}
                  value={selectedFromDate}
                  disableFuture
                  minDate={minDate}
                  //format="DD/MM/YYYY" // Specify the desired date format here
                  format={language === "de" ? "DD.MM.YYYY" : "DD/MM/YYYY"}
                  slotProps={{
                    field: {
                      readOnly: true,
                    },
                  }}
                />
              </div>
            </LocalizationProvider>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <div style={{ width: "150px", height: "30px", marginTop: "0px" }}>
                <DatePicker
                  label={strings[pageTitle][language].filterItems[8]}
                  onChange={handleDateToChange}
                  value={selectedToDate}
                  maxDate={dayjs()}
                  minDate={dayjs(selectedFromDate)}
                  format={language === "de" ? "DD.MM.YYYY" : "DD/MM/YYYY"}
                  slotProps={{
                    field: {
                      readOnly: true,
                    },
                  }}
                />
              </div>
            </LocalizationProvider>
          </div>
          {isLoading ? (
            <Loading />
          ) : (
            <>
              {currentEditingReason && (
                <h6>
                  <span className="grid-item-title">Editing reason: </span>{" "}
                  {currentEditingReason}
                </h6>
              )}
              <table
                style={{ boxSizing: "content-box", margin: "2em" }}
                className="activity-table"
              >
                <thead>
                  <tr className="tr-grid">
                    <th scope="col"></th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[0]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[1]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[2]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[3]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[4]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[5]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[6]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[7]}
                    </th>
                    <th scope="col">
                      {strings[pageTitle][language].tableHeaders[8]}
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {historyForms &&
                    historyForms.map((process, index) => (
                      <FormRowData
                        isAdmin
                        process={process}
                        key={process.processId}
                        isRunning={false}
                        isEditing={currentEditingReason ? true : false}
                        //   handleEndTime={handleEndTime}
                        //   swapCurrentRunning={(formId) => swapCurrentRunning(formId)}
                        //   pauseFunc={pauseCurrentProccess}
                        //   resumeFunc={resumeProcess}
                        handleFetchProcesses={handleFetchFilteredProcesses}
                        processDataCache={processDataCache}
                        setProcessDataCache={setProcessDataCache}
                        showSuccessMessage={function showSuccessMessage() {
                          setSnackbarData({
                            ...snackbarData,
                            message: "Form saved successfully!",
                            show: true,
                            severity: "success",
                          });
                        }}
                      />
                    ))}
                </tbody>
              </table>

              <div
                style={{ borderBottom: "1px solid black", margin: "1em" }}
              ></div>
              <nav className="pagination-container">
                <ul className="pagination">
                  <li>
                    <Button
                      onClick={() => {
                        setFilter({ ...filter, page: 1 });
                        setCurrentPage(1);
                        handleFetchFilteredProcesses("", 1);
                      }}
                      disabled={currentPage == 1 || currentPage == 0}
                    >
                      <FirstPageIcon></FirstPageIcon>{" "}
                      {strings[pageTitle][language].first}
                    </Button>
                  </li>
                  <li>
                    <Button
                      onClick={() => {
                        setFilter({ ...filter, page: currentPage - 1 });

                        setCurrentPage(currentPage - 1);
                        handleFetchFilteredProcesses("", currentPage - 1);
                      }}
                      disabled={currentPage == 1 || currentPage == 0}
                    >
                      <ArrowBackIosIcon></ArrowBackIosIcon>{" "}
                      {strings[pageTitle][language].previous}
                    </Button>
                  </li>
                </ul>

                <p>
                  {strings[pageTitle][language].page} {currentPage}{" "}
                  {strings[pageTitle][language].of} {numberOfPages} (
                  {numberOfItems} {strings[pageTitle][language].items})
                </p>
                <ul className="pagination">
                  <li>
                    <Button
                      onClick={() => {
                        setFilter({ ...filter, page: currentPage + 1 });

                        setCurrentPage(currentPage + 1);
                        handleFetchFilteredProcesses("", currentPage + 1);
                      }}
                      disabled={currentPage === numberOfPages}
                    >
                      {strings[pageTitle][language].next}{" "}
                      <ArrowForwardIosIcon></ArrowForwardIosIcon>
                    </Button>
                  </li>
                  <li>
                    <Button
                      onClick={() => {
                        console.log(numberOfPages);

                        setCurrentPage(numberOfPages);
                        handleFetchFilteredProcesses("", numberOfPages);
                      }}
                      disabled={currentPage == numberOfPages}
                    >
                      {strings[pageTitle][language].last}
                      <LastPageIcon></LastPageIcon>
                    </Button>
                  </li>
                </ul>
              </nav>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminEditRecords;
